import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import Jogo from "../../../models/Jogo";
import { addJogo, getDadosJogo, clearAllData } from "../../../db/db";
import "./NovoAmistoso.css";
import { Footer } from "../../components/Footer/Footer";

const NovoAmistoso = () => {
  const [dadosJogo, setDadosJogo] = useState([]);
  const [nomeSessao, setNomeSessao] = useState("");
  const [jogadoresPorTime, setJogadoresPorTime] = useState("");
  const [tempoDeJogo, setTempoDeJogo] = useState("");
  const [pontosParaAcabar, setPontosParaAcabar] = useState("");
  const [dadosIndividuais, setDadosIndividuais] = useState(false);
  const [corTime1, setCorTime1] = useState("#000000"); // Cor inicial do Time 1
  const [corTime2, setCorTime2] = useState("#8cff53"); // Cor inicial do Time 2
  const [maxVictories, setMaxVictories] = useState(""); // Nº máximo de vitórias

  useEffect(() => {
    const fetchJogo = async () => {
      try {
        const jogo = await getDadosJogo(); // Supondo que você tenha um ID fixo para o jogo
        setDadosJogo(jogo);
        if (jogo) {
          setNomeSessao(jogo[jogo.length - 1].nome);
          setJogadoresPorTime(jogo[jogo.length - 1].jogadoresPorTime);
          setTempoDeJogo(jogo[jogo.length - 1].tempoDeJogo);
          setPontosParaAcabar(jogo[jogo.length - 1].pontosParaAcabar);
          setMaxVictories(jogo[jogo.length - 1].maxVictories);
        }
      } catch (error) {
        console.error("Erro ao carregar o jogo:", error);
      }
    };

    fetchJogo();
  }, []);

  const navigate = useNavigate();

  const handleToggleDadosIndividuais = () => {
    setDadosIndividuais(!dadosIndividuais);
  };

  const handleAvancar = async () => {
    // Verificação dos campos vazios
    if (
      !nomeSessao ||
      !jogadoresPorTime ||
      !tempoDeJogo ||
      !pontosParaAcabar ||
      !maxVictories
    ) {
      alert("Por favor, preencha todos os campos antes de avançar.");
      return;
    }

    try {
      const novoJogo = new Jogo(
        nomeSessao,
        "futebol",
        parseInt(jogadoresPorTime),
        parseInt(tempoDeJogo),
        parseInt(pontosParaAcabar),
        dadosIndividuais,
        corTime1,
        corTime2,
        parseInt(maxVictories)
      );

      // Salvar no IndexedDB
      await addJogo(novoJogo);

      // Redireciona para a próxima página
      navigate("/novo-amistoso/incluir-jogadores");
    } catch (error) {
      console.error("Erro ao salvar os dados:", error);
      alert("Ocorreu um erro ao salvar os dados. Tente novamente.");
    }
  };

  const handleLimparDados = async () => {
    const confirmacao = window.confirm(
      "Tem certeza de que deseja limpar todos os dados? Esta ação não pode ser desfeita."
    );

    if (confirmacao) {
      try {
        await clearAllData(); // Limpa os dados do IndexedDB
        localStorage.clear(); // Limpa os dados armazenados no localStorage

        // Reseta os estados da interface
        setNomeSessao("");
        setJogadoresPorTime("");
        setTempoDeJogo("");
        setPontosParaAcabar("");

        alert("Todos os dados foram apagados com sucesso.");
      } catch (error) {
        console.error("Erro ao limpar os dados:", error);
        alert("Ocorreu um erro ao tentar limpar os dados.");
      }
    }
  };

  return (
    <>
      <Header />

      <div className="body">
        <div className="center">
          <div className="body-content card">
            <div className="topo-page">
              <strong># Novo Amistoso</strong>
            </div>

            <div className="area-novo-jogo">
              <label className="label-app" htmlFor="nome-sessao">
                | Nome da sessão:
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="text"
                  name="nome-sessao"
                  id="nome-sessao"
                  value={nomeSessao}
                  onChange={(e) => setNomeSessao(e.target.value)}
                />
              </div>

              <label className="label-app" htmlFor="nome-sessao">
                | Número de jogadores por time:{" "}
                <small>(não conta goleiro)</small>
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="number"
                  name="jogadores-por-time"
                  id="jogadores-por-time"
                  value={jogadoresPorTime}
                  onChange={(e) => setJogadoresPorTime(e.target.value)}
                />
              </div>

              <label className="label-app" htmlFor="tempo-jogo">
                | Tempo de jogo: <small>(em minutos)</small>
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="number"
                  name="tempo-jogo"
                  id="tempo-jogo"
                  value={tempoDeJogo}
                  onChange={(e) => setTempoDeJogo(e.target.value)}
                />
              </div>

              <label className="label-app" htmlFor="pontos-fim">
                | Pontos para acabar:
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="number"
                  name="pontos-fim"
                  id="pontos-fim"
                  value={pontosParaAcabar}
                  onChange={(e) => setPontosParaAcabar(e.target.value)}
                />
              </div>

              <label className="label-app" htmlFor="max-victories">
                | Nº máximo de vitórias:
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="number"
                  name="max-victories"
                  id="max-victories"
                  value={maxVictories}
                  onChange={(e) => setMaxVictories(e.target.value)}
                />
              </div>

              <div className="input-toggle-area">
                <label className="label-app" htmlFor="registrar-dados">
                  Registrar dados individuais
                </label>
                <div className="toggle-area">
                  <input
                    className="toggle-checkbox"
                    type="checkbox"
                    name="registrar-dados"
                    id="registrar-dados"
                    checked={dadosIndividuais}
                    onChange={handleToggleDadosIndividuais}
                  />
                </div>
              </div>

              <label className="label-app" htmlFor="cor-time1">
                | Cor do Time 1:
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="color"
                  name="cor-time1"
                  id="cor-time1"
                  value={corTime1}
                  onChange={(e) => setCorTime1(e.target.value)}
                />
              </div>

              <label className="label-app" htmlFor="cor-time2">
                | Cor do Time 2:
              </label>
              <div className="input-area">
                <input
                  className="input-app"
                  type="color"
                  name="cor-time2"
                  id="cor-time2"
                  value={corTime2}
                  onChange={(e) => setCorTime2(e.target.value)}
                />
              </div>

              <div className="buttons-bottom">
                {dadosJogo.length > 0 && (
                  <button
                    className="clear-data"
                    onClick={() => {
                      if (
                        window.confirm(
                          "Tem certeza que deseja limpar os dados?"
                        )
                      ) {
                        handleLimparDados();
                      }
                    }}
                  >
                    Limpar dados
                  </button>
                )}
                <button
                  id="novo-jogo"
                  className="btn-default"
                  onClick={handleAvancar}
                >
                  <strong>AVANÇAR</strong>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default NovoAmistoso;
